import CircularProgressWithLabel from 'Components/CircularProgress';
import useTranslation from 'Hooks/useTranslation';
import { DropzoneArea, DropzoneText, spanStyle } from 'Pages/EditCourseLessons/Views/LessonVideo/style';
import React from 'react';

/**
 * Muestra el indicador de progreso cuando se sube una lección de video.
 * Este progreso era usado con el servicio de "Firebase Storage".
 *
 * @param {Object} props
 * @param {number} props.progress - Progreso de la subida del archivo.
 * @param {boolean} [props.visible=true] - Indica si se muestra el indicador de progreso.
 * @param {Function} props.getInputProps - Función para obtener las propiedades del input.
 * @param {Function} props.getRootProps - Función para obtener las propiedades del root.
 * @param {string} props.uploadFiles - Imagen de subida de archivos.
 * @param {Array} props.acceptedFileItems - Archivos aceptados.
 * @param {Array} props.fileRejectionItems - Archivos rechazados.
 */
const DropzoneAreaIndicator = ({
  progress,
  visible = true,
  getInputProps,
  getRootProps,
  uploadFiles,
  acceptedFileItems,
  fileRejectionItems,
}) => {
  if (!visible || !progress) return <></>;

  if (progress !== 0) {
    return <CircularProgressWithLabel value={progress} />;
  }

  // Traducción
  const { t2 } = useTranslation('EditCourse');

  return (
    <DropzoneArea {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <img style={{ width: '20%', marginTop: '1rem' }} src={uploadFiles} />
      <DropzoneText>
        <p style={{ textAlign: 'center' }}>
          {t2('DragAndDropVideo')}
          <br />
          <br />
          {t2('Find')}
          <span style={spanStyle}>{t2('Desktop')}</span>
        </p>
        <div style={{ margin: 'auto' }}>{acceptedFileItems}</div>
        {fileRejectionItems.length > 0 ? (
          <h4 style={{ color: 'red', margin: '0' }}>{t2('VideoUploadTypeError')}</h4>
        ) : null}
      </DropzoneText>
    </DropzoneArea>
  );
};

export default DropzoneAreaIndicator;
